import { render, staticRenderFns } from "./IntroUserProfiles.vue?vue&type=template&id=1929f90a&"
import script from "./IntroUserProfiles.vue?vue&type=script&lang=js&"
export * from "./IntroUserProfiles.vue?vue&type=script&lang=js&"
import style0 from "./IntroUserProfiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports